import TourButton from '@app/components/ui/TourButton'
import { formTourSiteUrl } from '@app/config'
import { rem } from '@app/theme/materialUITheme'
import { Divider, Grid, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme: Theme) => ({
  tour: {
    color: theme.palette.primary.main,
    fontSize: rem(18),
    fontWeight: 600,
    textDecoration: 'none',
  },
  tourContainer: {
    justifyContent: 'center',
  },
}))

const TourCondensedInfo = () => {
  const classes = useStyles()
  const tournamentSite = useSelector((state: StoreState) => state.tournamentReducer.tournamentSite)

  if (!tournamentSite?.tournament?.tourCondensed) {
    return null
  }

  return (
    <>
      <Divider style={{ width: '100%', margin: '30px 0' }} />

      <Grid container item xs={12} className={classes.tourContainer}>
        <Typography variant={'h2'} style={{ textAlign: 'center', marginBottom: 16 }}>
          <FormattedMessage id={'strings.tour'} />
        </Typography>

        <Grid container style={{ justifyContent: 'center' }}>
          {tournamentSite.tournament.tourCondensed.logo && (
            <Grid item xs={12} sm={6} style={{ textAlign: 'center', marginBottom: 10 }}>
              <img
                style={{ maxWidth: '100%', maxHeight: 115 }}
                src={tournamentSite.tournament.tourCondensed.logo.url}
                alt=""
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} style={{ textAlign: 'center', marginBottom: 10 }}>
            <Typography variant="body1">
              <FormattedMessage id="strings.partOfTour" />
              <br />
              <a href={formTourSiteUrl(tournamentSite.tournament.tourCondensed.id)} className={classes.tour}>
                {tournamentSite.tournament.tourCondensed.name}
              </a>
            </Typography>

            <a href={formTourSiteUrl(tournamentSite.tournament.tourCondensed.id)} style={{ textDecoration: 'none' }}>
              <TourButton
                buttonProps={{
                  style: { marginTop: 30 },
                }}
              >
                <FormattedMessage id={'buttons.viewTourSite'} />
              </TourButton>
            </a>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default TourCondensedInfo
